import { FC } from "react";

import TopNav from "../../components/TopNav/TopNav";
import ContentLayout from "../ContentLayout/ContentLayout";
import { SuperuserLayoutProps } from "./types";

import styles from "./SuperuserLayout.module.css";



const SuperuserLayout: FC<SuperuserLayoutProps> = ({ children }) => {
  return (
    <div className={styles["superuser-layout"]}>
      <TopNav title="Superuser mode" />
      <ContentLayout>{children}</ContentLayout>
    </div>
  );
};

export default SuperuserLayout;
